// تبويب "الموظفون" داخل صفحة /permissions — القائمة القابلة للبحث السابقة.
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";
import { CardHeader, ToneCard } from "../admin/cardTone";
import { listUsers } from "../../api/directory";
import { PermsButton } from "./PermsButton";

export function UsersPermsTab() {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    listUsers("", "").then(setUsers).catch(() => setUsers([]));
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return users;
    return users.filter((u) => (u.name || "").toLowerCase().includes(q)
                              || (u.email || "").toLowerCase().includes(q));
  }, [users, query]);

  return (
    <ToneCard tone="sky" testId="perms-users">
      <CardHeader icon={Users} tone="sky" title={t("perms.pickEmployee")} />
      <NeuInput className="mt-4" data-testid="perms-user-search"
                placeholder={t("employees.search")}
                value={query} onChange={(e) => setQuery(e.target.value)} />
      <ul className="mt-4 grid gap-2" data-testid="perms-user-list">
        {filtered.map((u) => (
          <li key={u.id} className="flex flex-wrap items-center justify-between gap-3
                                     rounded-2xl border border-border/50 px-4 py-3">
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-bold">{u.name || u.email}</p>
              <p className="truncate text-[11px] text-muted-foreground">
                {u.email} · {t(`roles.${u.role || "employee"}`)}
              </p>
            </div>
            <PermsButton userId={u.id} userName={u.name || u.email} small />
          </li>
        ))}
        {filtered.length === 0
          ? <p className="py-8 text-center text-sm text-muted-foreground">{t("app.none")}</p>
          : null}
      </ul>
    </ToneCard>
  );
}
